import React from 'react'
import './References.css'
const people = [
    {
        name: 'Ivan Soo-Hoo Weng Kit',
        role: 'Software Engineer at Papercut',
        imageUrl:
            'https://media.licdn.com/dms/image/v2/D5603AQHkIS3AGNzi_w/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1693047161313?e=1743033600&v=beta&t=p_3PkFiWoviLdDEplUqGlyGv3rceuVBtkIqPloF8rwQ',
        linkedIn: 'https://www.linkedin.com/in/weng-kit-soo-hoo-553a36258/',
        email: 'ivansoohoo@hotmail.com',
        phoneNumber: '+61 405-362-439'
    },
    {
        name: 'Davin Karunanayake',
        role: 'Co-founder & CTO of Huddled',
        imageUrl:
            'https://media.licdn.com/dms/image/v2/D5603AQFjwX8ZH16BBw/profile-displayphoto-shrink_200_200/B56ZQv8TRDHIAY-/0/1735971125178?e=1743033600&v=beta&t=7zZEHkf7WYACHugB4ArEvN6TrRO8J8DkeeRIpuMtbdE',
        linkedIn: 'https://www.linkedin.com/in/davinkaru/',
        email: 'davin@huddled.net',
        phoneNumber: ''
    },
    {
        name: 'Archer Simmonds',
        role: 'Co-Founder & COO of Huddled',
        imageUrl:
            'https://media.licdn.com/dms/image/v2/D5603AQGGSUqIfsxRsg/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723504600459?e=1743033600&v=beta&t=SM_xn3_LZnO_vK7OU5IxcIBNf3S1_ouDQ6HZWtpO-Wg',
        linkedIn: 'https://www.linkedin.com/in/archer-simmonds-979454197/',
        email: 'Archer.Simmonds@gmail.com',
        phoneNumber: ''

    },

]
const ReferencesCard = () => {
    return (
        <div className=" py-24 sm:py-32">
            <div className="mx-auto grid max-w-7xl gap-20 px-6 lg:px-8 xl:grid-cols-3">
                <div className="max-w-xl">
                    <h2 className="text-pretty text-3xl font-semibold tracking-tight text-slate-100 sm:text-4xl">
                        Here are my references!
                    </h2>
                    <p className="mt-6 text-lg/8 text-slate-400">
                        In the past I have worked with some amazing people. Here are some of the people I have worked with and some details about them!
                    </p>
                </div>
                <ul className="grid gap-x-8 gap-y-12 sm:grid-cols-1 sm:gap-y-16 xl:col-span-2 ">
                    {people.map((person) => (
                        <li key={person.name}>
                            <div className="flex items-center justify-between w-100 backdrop-blur-2xl bg-slate-600/30 rounded-lg p-6 shadow-xl shadow-gray-500/30">
                                <div className="flex items-center gap-x-6">
                                    <img alt="" src={person.imageUrl} className="size-16 rounded-full" />
                                    <div>
                                        <h3 className="text-base/7 font-semibold tracking-tight text-slate-100">{person.name}</h3>
                                        <p className="text-sm/6 font-semibold text-indigo-300">{person.role}</p>
                                        <div className="flex flex-col gap-x-3 sm:flex-row sm:gap-y-0">
                                            {person.email && (
                                                <a
                                                    href={`mailto:${person.email}`}
                                                    aria-label={`Email ${person.name}`}
                                                    className="text-sm/6 font-semibold text-slate-300 cursor-pointer">
                                                    {person.email}
                                                </a>
                                            )}
                                            {person.phoneNumber && (
                                                <a
                                                    href={`tel:${person.phoneNumber}`}
                                                    aria-label={`Call ${person.name}`}
                                                    className="text-sm/6 font-semibold text-slate-300 cursor-pointer">
                                                    {person.phoneNumber}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex gap-2 text-slate-300">
                                    {person.linkedIn && (
                                        <a
                                            href={person.linkedIn}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={`${person.name}'s LinkedIn`}
                                            className="cursor-pointer">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="currentColor"
                                                viewBox="0 0 448 512"
                                                className="h-5 w-5 text-slate-300 hover:text-indigo-300 hover:fill-indigo-300">
                                                <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                                            </svg>
                                        </a>
                                    )}

                                    {person.email && (
                                        <a

                                            href={`mailto:${person.email}`}
                                            aria-label={`Email ${person.name}`}
                                            className="cursor-pointer">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                className="h-5 w-5 text-slate-300 hover:text-indigo-300 hover:fill-indigo-300">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                                            </svg>
                                        </a>
                                    )}

                                    {person.phoneNumber && (
                                        <a
                                            href={`tel:${person.phoneNumber}`}
                                            aria-label={`Call ${person.name}`}
                                            className="cursor-pointer">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                className="h-5 w-5 text-slate-300 hover:text-indigo-300 hover:fill-indigo-300">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                                            </svg>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default ReferencesCard
